module.exports = __webpack_public_path__ + "static/2-e940895035985b104e8b799c6ce8d8bc.png";